<style lang="scss">




.getmore-left {
  display: none;
}
@keyframes showInLeft {
  0% {
    opacity: 0;
    transform: translateX(-1rem);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-1rem);
  }
}

.buttonRight {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 10rem;

  .getmore-button {
    width: 8rem;
    height: 4rem;
    background-color: white;
    border: solid 0.3rem #e5004f;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .getmore-title {
      font-family:  'PingFang SC','Microsoft YaHei';
      color: #e5004f;
      font-size: 1.2rem;
    }
    &:hover {
      width: 10rem;
      cursor: pointer;
      transition: all 0.2s;

      .getmore-left {
        animation: showInLeft 1s 1;
        display: inline-block;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 500;
        color: #e5004f;
        font-size: 1.2rem;
        margin-left: 1rem;
      }
    }
  }
}
</style>

<template>
  <div class="buttonRight">
    <div class="getmore-button">
      <div class="getmore-title">
        查看更多<span class="getmore-left">></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "buttonRight",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
